// Module
var code = "<!-- ko if: status() > 0 -->\n<svg-icon params=\"name: 'correct-mark'\"></svg-icon>\n<!-- /ko -->\n<!-- ko if: status() < 0 -->\n<svg-icon params=\"name: 'incorrect-mark'\"></svg-icon>\n<!-- /ko -->\n<!-- ko if: status() == 0 -->\n<svg-icon params=\"name: 'part-correct-mark'\"></svg-icon>\n<!-- /ko -->\n";
// Exports
module.exports = code;